import React from "react";
import OrderTaskForm from "./OrderTaskForm";

// Tarea «Entregar en tienda» (actor DESPACHO) — FORMCODE ELTIE
const CONFIG = {
  stage: 1,
  title: "Entregar en tienda",
  intro: "El cliente retira su pedido en la tienda.",
  sections: ["pedido", "productos", "montos", "cliente", "entrega", "facturacion"],
  checklist: [
    "Pide el número de pedido o el nombre del cliente.",
    "Verifica que los productos coincidan antes de entregar.",
    "Si el cliente no se presenta, cierra el pedido como no retirado.",
  ],
  optionHints: {
    "Entregado": "Cierra el pedido.",
    "No retiró / cancelar": "Cierra el pedido sin entrega.",
  },
};

export default function ElevaxEntregarTienda(props) {
  return <OrderTaskForm {...props} config={CONFIG} />;
}
